<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    yesText: {
      type: String,
      required: true,
    },
    noText: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeDialog(action) {
      this.$emit('closeDeleteDialog', action)
      this.$emit('update:dialog', false)
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="308" persistent>
      <v-card class="pa-3">
        <v-card-title :class="$style.confirmText">
          {{ content }}
        </v-card-title>

        <v-card-actions class="mx-auto mt-0 pt-0">
          <div>
            <v-btn
              color="#0476D9"
              text
              :class="$style.txtBtn"
              @click="closeDialog('no')"
            >
              {{ noText }}
            </v-btn>

            |

            <v-btn
              color="#0476D9"
              text
              :class="[$style.txtBtn, $style.bold]"
              @click="closeDialog('yes')"
            >
              {{ yesText }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.txtBtn {
  padding: 0 !important;
  font-size: 14px !important;
  color: #0476d9 !important;
  text-transform: none;
  background: none !important;
  border: none;
  box-shadow: none !important;
}

.bold {
  font-weight: 700;
}
.confirmText {
  font-size: 14px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 150%;
  word-break: keep-all !important;
  word-wrap: normal !important;
}
</style>
